import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { MainContextState, MainContext } from "../../../../context/MainContext";
import { ReportTableCreator } from "./ReportTableCreator";
import { form3Rows, form3HeaderCells } from "../helpers/form3";

interface IProps {
    editForm?: boolean;
}

export const Form3EditForm = ({ editForm = false }: IProps) => {
    const { constants } = useContext<Partial<MainContextState>>(MainContext);

    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    return (
        <>
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                    Форма 2
                </Typography>
            </Box>
            <ReportTableCreator bodyCell={form3Rows} headerCell={form3HeaderCells} />
        </>
    );
};
